import { Info, Clock, Scale, Euro, Accessibility } from "lucide-react";

export function BandoPanel({ rif }) {
  if (!rif) return null;
  const Item = ({ icon: Icon, title, children }) => (
    <div className="flex gap-3">
      <div className="h-7 w-7 shrink-0 rounded-md bg-white border border-blue-100 text-[#003087] flex items-center justify-center"><Icon size={14} strokeWidth={1.75} /></div>
      <div className="min-w-0"><div className="text-sm font-medium text-slate-900">{title}</div><div className="text-xs text-slate-600 mt-0.5 leading-relaxed">{children}</div></div>
    </div>
  );
  return (
    <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 space-y-4" data-testid="bando-panel">
      <div className="flex items-center gap-2"><Info size={16} className="text-[#003087]" /><h3 className="font-heading font-medium text-slate-900">Regole del bando-tipo</h3></div>
      <Item icon={Clock} title="Tempistiche">Gare avviate entro il 30/06/2027, completate entro il 30/09/2027. Bandi pubblicati ≥ 6 mesi prima della scadenza.</Item>
      <Item icon={Scale} title="Aggiudicazione">OEPV: offerta tecnica {rif.criterio_aggiudicazione.peso_tecnica_pct}% · economica max {rif.criterio_aggiudicazione.peso_economica_pct}%. Premiali: PMI, clausole sociali.</Item>
      <Item icon={Clock} title="Durata">{rif.durata.min_anni}–{rif.durata.max_anni} anni, commisurata agli investimenti e al loro ammortamento.</Item>
      <Item icon={Euro} title="Indennizzo all'uscente">Investimenti non ammortizzati + equa remunerazione degli investimenti degli ultimi 5 anni.</Item>
      <Item icon={Accessibility} title="Accessibilità">WC adattato, doccia con spazio carrozzina, percorsi complanari, passerelle ≥ 1,20 m.</Item>
      <p className="text-[11px] text-slate-500 border-t border-blue-100 pt-3">{rif.fonte}. {rif.stato}.</p>
    </div>
  );
}
